export default __webpack_public_path__ + "static/media/dele-logo-with-text.207d27b6.svg";